import Vue from 'vue';
import moment from "moment";

Vue.filter('dateformat', (value,format)=>{
    if (!value) return ''

    return moment.unix(value).format(format);
})

Vue.filter('wan', function (value) {
    const num = parseInt(value)
    const num2 = num / 10000
    if (num2 >= 1) {
        return Math.round(num2 * 100) / 100 + '万'
    } else {
        return num>0?num:'-'
    }
})

Vue.filter('fans', function (value) {
    const num = parseInt(value)
    if(num>=10000000)
    {
        return '1000万+'
    }
    const num2 = num / 10000
    if (num2 >= 1) {
        return Math.round(num2 * 100) / 100 + '万'
    } else {
        return num>0?num:'-'
    }
})

/**
 * 媒体资源页的友好时间
 */
Vue.filter('friendlyRes',function(date){
    const dateObject = new Date(Vue.options.filters.dateformat(date,'YYYY-MM-DD HH:mm'));
    const yest = new Date(new Date()-3600*24*1000);
    const yestyest = new Date(new Date()-3600*24*1000*2);

    if(dateObject.toDateString() === new Date().toDateString())
    {
        if(new Date().getTime()-dateObject.getTime()<3600*6*1000)
        {
            return '<span style="color:#F44336">刚刚</span>'
        }

        return '<span style="color:#F44336">今天<span>'
    }

    if(dateObject.toDateString() ===yest.toDateString())
    {
        return '<span style="color:#FF9800;">昨天</span>'
    }

    if(dateObject.toDateString() ===yestyest.toDateString())
    {
        return '<span style="color:#4caf50;">前天</span>'
    }


    return Vue.options.filters.dateformat(date,'MM-DD');
})